import {Mapper} from '@s-ui/domain'

export default class FromMakesRawDataToMakesListValueObjectMapper extends Mapper {
  constructor({makeEntityFactory, valueObject}) {
    super()
    this._makeEntityFactory = makeEntityFactory
    this._valueObject = valueObject
  }

  map = ({items}) => {
    const itemsList = items.map(({id, label}) => this._makeEntityFactory({id, name: label}))
    return this._valueObject({items: itemsList})
  }
}
